<template>
  <article class="slide" :class="getClasses" :style="getStyles">
    <template v-if="slide.type[0].target_id == 'text'">
      <div class="regular-text" v-html="slide.field_text[0].processed"></div>
    </template>

    <template v-if="slide.type[0].target_id == 'image'">
      <div>
        <img v-bind:src="slide.field_image[0].uri[0].url | buildUrl" alt />
      </div>
    </template>

    <template v-if="slide.type[0].target_id == 'video'">
      <div>
        <video autoplay loop muted playsinline>
          <source
            v-bind:src="slide.field_video[0].uri[0].url | buildUrl"
            type="video/mp4"
          />
        </video>
      </div>
    </template>
  </article>
</template>

<script>
export default {
  props: {
    slide: Object,
  },
  computed: {
    getClasses() {
      return {
        "slide-text": this.slide.type[0].target_id == "text",
        "slide-image": this.slide.type[0].target_id == "image",
        "slide-video": this.slide.type[0].target_id == "video",
        "no-padding": this.slide.field_padding
          ? this.slide.field_padding[0].value === "no-padding"
          : false,
      };
    },
    getStyles() {
      return {
        "--slide-background-color":
          this.slide &&
          this.slide.field_background_color &&
          this.slide.field_background_color.length
            ? this.slide.field_background_color[0].value
            : null,
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";

.slide {
  position: relative;
  box-sizing: border-box;
  background-color: var(--slide-background-color, #fff);

  @include breakpoint(xs) {
    background-color: transparent !important;
    color: inherit !important;
    margin: var(--slide-padding-mobile);

    &:first-child {
      margin-top: var(--slide-padding-top-mobile-first-slide) !important;
    }
  }

  &.slide-text {
    @include breakpoint(xs) {
      margin: var(--slide-text-padding-mobile);
    }
  }

  @include breakpoint(sm) {
    height: calc(var(--vh, 1vh) * 100);
    scroll-snap-align: start;
    margin: 0;
    padding: var(--slide-padding-tablet);

    &.no-padding {
      padding: 0;

      & > div {
        img,
        video {
          object-fit: cover;
          @include breakpoint(xs) {
            object-fit: contain;
          }
        }
      }
    }
  }

  @include breakpoint(md) {
    padding: var(--slide-padding);
  }

  .slide-number {
    position: absolute;
  }

  & > div {
    // align items inside each article
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0;
    width: 100%;
    height: 100%;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
